module.exports = __webpack_public_path__ + "img/gh-31501____1.prt.7769c8fa.jpg";